import { base } from './base';
import { AT } from './AT';

export const featureConfigMap = {
    base,
    AT,
};
